<script setup>
import {onMounted, ref} from 'vue';

defineOptions({
    inheritAttrs: true,
});

defineProps({
    name: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: 'text',
    },
    modelValue: {
        type: String,
        default: null,
    },
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({focus: () => input.value.focus()});
</script>

<template>
    <input
        :id="name"
        ref="input"
        :type="type"
        :name="name"
        class="mt-3 w-full border border-black/20 bg-transparent px-4 py-3 text-black/70 outline-none focus:ring-1 focus:ring-secondary focus:border-secondary"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)" />
</template>
